import React from "react";

export default function Mail() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="4"
        width="18"
        height="13.2632"
        rx="3"
        stroke="#192617"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M4.78955 8.02637L8.82373 10.9603C9.52503 11.4704 10.4751 11.4704 11.1764 10.9603L15.2106 8.02637"
        stroke="#192617"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}
